import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const ProfilePage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Profile
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your user profile and account settings.
        </Typography>
        {/* Profile components will be added here */}
      </Box>
    </Container>
  );
};

export default ProfilePage;